/**
 * @deprecated Page location moved
 */
export const DEPRECATED_ROUTES = {
  CAMPS: '/camps',
  CAMP_BULK_CHANGE: '/camps/bulk-change',
  CAMP_EDIT: '/camps/:id',
  CAMP_EDIT_DASHBOARD: '/camps/:id/dashboard',
  CAMP_EDIT_LOGISTICS: '/camps/:id/logistics',
  CAMP_EDIT_SCHEDULE: '/camps/:id/schedule',
  CAMP_EDIT_DETAILS: '/camps/:id/details',
  CAMP_EDIT_FIELDS: '/camps/:id/fields',
  CAMP_EDIT_OPTIONS: '/camps/:id/options',
  CAMP_REGISTER: '/camps/:id/register',
  EMAIL_CREATE: '/camps/:id/email',
  CAMP_DUPLICATE: '/camps/:id/duplicate',
  CAMP_REGISTRATIONS: '/camps/:id/registrations',
  CAMP_CREATE: '/camps/create',
  CAMP_TRANSFER: '/camps/:id/transfer/:registration_id',
  EVENT_EMAIL_CREATE: '/events/:id/email',
  EMBED_SETTINGS: '/settings/embed',
}

export const ROUTES = {
  HOME: '/',
  SIGNUP: '/signup',
  LOGIN: '/login',
  LOGOUT: '/logout',
  FORGOT_PASSWORD: '/forgot-password',
  RECOVER_PASSWORD: '/recovery/:code',
  ACCEPT_INVITE: '/invite',
  SETUP: '/setup',
  DASHBOARD: '/dashboard',
  WHATS_NEW: '/whats-new',
  WHATS_NEW_DETAILS: '/whats-new/:id',
  TEAM: '/team',
  TEAM_INVITE: '/team/invite',
  FINANCIALS: '/financials',
  FINANCIALS_ORDERS: '/financials/orders',
  FINANCIALS_ORDER_CREATE: '/financials/orders/create',
  FINANCIALS_ORDER_DETAIL: '/financials/orders/:id',
  FINANCIALS_ORDER_REFUND: '/financials/orders/:id/refund',
  FINANCIALS_REFUND_UPDATE: '/financials/orders/:id/refund/:refund_id',
  FINANCIALS_ORDER_ITEM_ADD: '/financials/orders/:id/items/add',
  FINANCIALS_ORDER_ITEM_EDIT: '/financials/orders/:id/items/:order_item_id/edit',
  FINANCIALS_ORDER_ACTIVITY: '/financials/orders/:id/activity',
  FINANCIALS_PROCESS_PAYMENT: '/financials/orders/:id/payment',
  FINANCIALS_PAYMENT_CONFIRM: '/confirm-payment',
  FINANCIALS_REPORTS: '/financials/reports',
  FINANCIALS_REPORT_DETAIL: '/financials/reports/:type',
  FINANCIALS_TAX_RATES: '/financials/tax-rates',
  FINANCIALS_TAX_RATE_DETAIL: '/financials/tax-rates/:id',
  FINANCIALS_TAX_RATE_CREATE: '/financials/tax-rates/create',
  FINANCIALS_COUPONS: '/financials/coupons',
  FINANCIALS_COUPON_CREATE: '/financials/coupons/create',
  FINANCIALS_COUPON_DETAILS: '/financials/coupons/:id',
  FINANCIALS_COUPON_UPDATE: '/financials/coupons/:id/update',
  FINANCIALS_MEMBERSHIPS: '/financials/memberships',
  FINANCIALS_MEMBERSHIPS_CREATE: '/financials/memberships/create',
  FINANCIALS_MEMBERSHIP_DETAIL: '/financials/memberships/:id',
  FINANCIALS_MEMBERSHIP_UPDATE: '/financials/memberships/:id/update',
  FINANCIALS_PAYOUTS: '/financials/payouts',
  EVENTS: '/events',
  EVENT_LIST_VIEW: '/events?view=list',
  EVENT_CALENDAR_VIEW: '/events?view=calendar',
  EVENT_APPOINTMENT_VIEW: '/events?view=appointment',
  EVENT_BULK_CHANGE: '/events/bulk-change',
  EVENT_EDIT: '/events/:id',
  EVENT_EDIT_DASHBOARD: '/events/:id/dashboard',
  EVENT_EDIT_LOGISTICS: '/events/:id/logistics',
  EVENT_EDIT_SCHEDULE: '/events/:id/schedule',
  EVENT_EDIT_DETAILS: '/events/:id/details',
  EVENT_EDIT_FIELDS: '/events/:id/fields',
  EVENT_EDIT_OPTIONS: '/events/:id/options',
  EVENT_REGISTER: '/events/:id/register',
  EVENT_DUPLICATE: '/events/:id/duplicate',
  EVENT_REGISTRATIONS: '/events/:id/registrations',
  EVENT_TRANSFER: '/events/:id/transfer/:registration_id',
  EVENT_CREATE: '/events/create',
  APPOINTMENT_EDIT: '/events/appointments/:id',
  APPOINTMENT_EDIT_DASHBOARD: '/events/appointments/:id/dashboard',
  APPOINTMENT_EDIT_LOGISTICS: '/events/appointments/:id/logistics',
  APPOINTMENT_EDIT_SCHEDULE: '/events/appointments/:id/schedule',
  APPOINTMENT_EDIT_DETAILS: '/events/appointments/:id/details',
  APPOINTMENT_EDIT_OPTIONS: '/events/appointments/:id/options',
  APPOINTMENT_EDIT_FIELDS: '/events/appointments/:id/fields',
  APPOINTMENT_REGISTER: '/events/appointments/:id/register',
  APPOINTMENT_RESCHEDULE: '/events/appointments/:id/reschedule/:registration_id',
  APPOINTMENT_TYPE_CREATE: '/events/appointments/create',
  CONTACTS: '/contacts',
  CONTACTS_CREATE: '/contacts/create',
  CONTACTS_IMPORT: '/contacts/import',
  CONTACTS_REPORT: '/contacts/report',
  CONTACT_DETAILS: '/contacts/:id',
  CONTACT_EDIT: '/contacts/:id/edit',
  CONTACT_ADD_CREDITS: '/contacts/:id/credits/create',
  CONTACT_CREDITS: '/contacts/:id/credits',
  CONTACT_TRANSACTIONS: '/contacts/:id/transactions',
  CONTACT_ADJUST_BALANCE: '/contacts/:id/transactions/adjust',
  CONTACT_ADD_MEMBERSHIP: '/contacts/:id/memberships/create',
  CONTACT_ACTIVITY: '/contacts/:id/activity',
  ATTENDEES: '/attendees',
  ATTENDEE_ACTIVITY: '/attendees/:id/activity',
  ATTENDEE_DETAILS: '/attendees/:id',
  ATTENDEES_MERGE: '/attendees/:id/merge',
  ATTENDEES_CREATE: '/attendees/create',
  ATTENDEES_IMPORT: '/attendees/import',
  ATTENDEES_REPORT: '/attendees/report',
  TASKS: '/tasks',
  INBOX: '/inbox',
  INBOX_CONVERSATION_DETAILS: '/inbox/:id',
  INBOX_CONVERSATION_COMPOSE: '/inbox/compose',
  MARKETING: '/marketing',
  MARKETING_CAMPAIGNS: '/marketing/campaigns',
  MARKETING_CAMPAIGN_CREATE: '/marketing/campaigns/create',
  MARKETING_CAMPAIGN_DETAIL: '/marketing/campaigns/:id',
  MARKETING_CAMPAIGN_EDIT: '/marketing/campaigns/:id/edit',
  MARKETING_CAMPAIGN_PREVIEW: '/marketing/campaigns/:id/preview',
  MARKETING_CAMPAIGN_OVERVIEW: '/marketing/campaigns/:id/overview',
  MARKETING_CAMPAIGN_ACTIVITY: '/marketing/campaigns/:id/activity',
  MARKETING_CAMPAIGN_CLICKS: '/marketing/campaigns/:id/clicks',
  MARKETING_LINKS: '/marketing/links',
  MARKETING_LINK_CREATE: '/marketing/links/create',
  MARKETING_LINK_DETAIL: '/marketing/links/:id',
  MARKETING_LINK_QRCODE: '/marketing/links/:id/qrcode',
  MARKETING_INSIGHTS: '/marketing/insights',
  IMPORT: '/import',
  SETTINGS: '/settings',
  PROFILE_SETTINGS: '/settings/profile',
  CHANGE_PASSWORD: '/settings/change-password',
  PROGRAM_SETTINGS: '/settings/program',
  WAIVER_SETTINGS: '/settings/waiver',
  REFUND_POLICY_SETTINGS: '/settings/refund-policy',
  PACKAGES: '/settings/packages',
  MEMBER_PACK_CREATE: '/settings/packages/membership/create',
  MEMBER_PACK_DETAILS: '/settings/packages/membership/:id',
  NOTIFICATION_SETTINGS: '/settings/notifications',
  SESSION_PACK_CREATE: '/settings/packages/session/create',
  SESSION_PACK_DETAILS: '/settings/packages/session/:id',
  BRANDING_SETTINGS: '/settings/branding',
  EVENT_SETTINGS: '/settings/events',
  FILTER_SETTINGS: '/settings/filters',
  CONNECT_SETTINGS: '/settings/connect',
  /**
   * @deprecated Page location moved
   */
  PAYOUT_SETTINGS: '/settings/payout',
  PAYMENT_SETTINGS: '/settings/payments',
  PAYOUTS: '/settings/payments/payouts',
  PAYOUT_ACCOUNT: '/settings/payments/account',
  BILLING_SETTINGS: '/settings/billing',
  TERMINALS: '/settings/terminals',
  TERMINAL_CREATE: '/settings/terminals/create',
  PROGRAM_ACTIVITY: '/settings/activity',
  ERROR: '/error',
  NOT_FOUND: '/404',
}
